export default "__VITE_ASSET__3d9WoICS__"